// tabs/CommissionTab.jsx - Commission tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Radio, Paper } from '@mantine/core';

const CommissionTab = ({ quoteData, setQuoteData }) => {
  const [commissionData, setCommissionData] = useState({
    salespersonAccounts: [
      { 
        code: 'DD', 
        name: 'Derek Deur', 
        percentage: 3.0000, 
        calculateBy: 'doc', 
        method: 'net', 
        total: 0.00 
      },
      { code: '', name: '', percentage: 0.0000, calculateBy: 'doc', method: 'net', total: 0.00 },
      { code: '', name: '', percentage: 0.0000, calculateBy: 'doc', method: 'net', total: 0.00 },
      { code: '', name: '', percentage: 0.0000, calculateBy: 'doc', method: 'net', total: 0.00 },
      { code: '', name: '', percentage: 0.0000, calculateBy: 'doc', method: 'net', total: 0.00 }
    ],
    assignedBuyer: ''
  });

  const handleSalespersonChange = (index, field, value) => {
    const newSalespersonAccounts = [...commissionData.salespersonAccounts];
    newSalespersonAccounts[index] = {
      ...newSalespersonAccounts[index],
      [field]: value
    };
    setCommissionData(prev => ({
      ...prev,
      salespersonAccounts: newSalespersonAccounts
    }));
  };

  const handleBuyerChange = (value) => {
    setCommissionData(prev => ({ ...prev, assignedBuyer: value }));
  };

  return (
    <Box p="md">
      <Paper withBorder p="md">
        <Text size="sm" fw={500} mb="md">Salesperson Accounts</Text>
        
        {/* Table Headers */}
        <Grid gutter="md" align="center" mb="sm">
          <Grid.Col span={1}>
            <Text size="sm" fw={500} ta="center">Code</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text size="sm" fw={500} ta="center">Name</Text>
          </Grid.Col>
          <Grid.Col span={2}>
            <Text size="sm" fw={500} ta="center">%</Text>
          </Grid.Col>
          <Grid.Col span={2}>
            <Text size="sm" fw={500} ta="center">Calculate by</Text>
          </Grid.Col>
          <Grid.Col span={2}>
            <Text size="sm" fw={500} ta="center">Method</Text>
          </Grid.Col>
          <Grid.Col span={2}>
            <Text size="sm" fw={500} ta="center">Total</Text>
          </Grid.Col>
        </Grid>

        {/* Salesperson Rows */}
        {commissionData.salespersonAccounts.map((salesperson, index) => (
          <Grid key={index} gutter="md" align="center" mb="sm">
            <Grid.Col span={1}>
              <Group spacing="xs">
                <Text size="sm" fw={500}>[{index + 1}]:</Text>
                <TextInput
                  value={salesperson.code}
                  variant="filled"
                  size="sm"
                  w={60}
                  styles={index === 0 ? { input: { fontWeight: 'bold', color: 'white', backgroundColor: 'blue' } } : {}}
                  onChange={(e) => handleSalespersonChange(index, 'code', e.target.value)}
                />
              </Group>
            </Grid.Col>
            <Grid.Col span={3}>
              <TextInput
                value={salesperson.name}
                variant="filled"
                size="sm"
                styles={index === 0 ? { input: { fontWeight: 'bold', color: 'blue' } } : {}}
                onChange={(e) => handleSalespersonChange(index, 'name', e.target.value)}
              />
            </Grid.Col>
            <Grid.Col span={2}>
              <Group spacing="xs">
                <NumberInput
                  value={salesperson.percentage}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={4}
                  fixedDecimalScale
                  onChange={(value) => handleSalespersonChange(index, 'percentage', value)}
                />
                <Text size="sm" fw={500}>%</Text>
              </Group>
            </Grid.Col>
            <Grid.Col span={2}>
              <Radio.Group
                value={salesperson.calculateBy}
                onChange={(value) => handleSalespersonChange(index, 'calculateBy', value)}
              >
                <Group spacing="xs">
                  <Radio value="doc" label="Doc" />
                  <Radio value="line" label="Line" />
                </Group>
              </Radio.Group>
            </Grid.Col>
            <Grid.Col span={2}>
              <Radio.Group
                value={salesperson.method}
                onChange={(value) => handleSalespersonChange(index, 'method', value)}
              >
                <Group spacing="xs">
                  <Radio value="net" label="N" />
                  <Radio value="gross" label="G" />
                </Group>
              </Radio.Group>
            </Grid.Col>
            <Grid.Col span={2}>
              <NumberInput
                value={salesperson.total}
                variant="filled"
                size="sm"
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleSalespersonChange(index, 'total', value)}
              />
            </Grid.Col>
          </Grid>
        ))}

        {/* Assigned Buyer */}
        <Group spacing="xs" align="flex-end" mt="lg">
          <Text size="sm" fw={500} w={120}>Assigned Buyer:</Text>
          <TextInput
            value={commissionData.assignedBuyer}
            variant="filled"
            size="sm"
            style={{ width: '200px' }}
            onChange={(e) => handleBuyerChange(e.target.value)}
          />
        </Group>
      </Paper>
    </Box>
  );
};

export default CommissionTab;